const separatorRegex = /\./
const dayRegex = /(0[1-9]|[1-2][0-9]|3[0-1])/ // day between 1 and 9 with a leading zero OR from 10 to 31
const monthRegex = /(0[1-9]|1[0-2])/ // month between 1 and 9 with a leading zero OR from 10 to 12
const yearRegex = /(19[0-9][0-9]|2[0-1][0-9][0-9])/ // year between 1900 and 2199
export const validDateRegex = new RegExp(
  "^" + dayRegex.source + separatorRegex.source + monthRegex.source + separatorRegex.source + yearRegex.source + "$",
)
// this regex is similar to the above one but allows partial dates as we type, e.g.
// d
// dd
// dd.
// dd.M
// dd.MM
// dd.MM.
// dd.MM.y
// dd.MM.yy
// dd.MM.yyy
// dd.MM.yyyy
const dayWhileTypingRegex = /([0-3]|0[1-9]|[1-2][0-9]|3[0-1])/ // day between 1 and 9 with a leading zero OR from 10 to 31
const monthWhileTypingRegex = /([0-1]|0[1-9]|1[0-2])/ // month between 1 and 9 with a leading zero OR from 10 to 12
const yearWhileTypingRegex = /([1-2]|19|2[0-1]|19[0-9]|2[0-1][0-9]|19[0-9][0-9]|2[0-1][0-9][0-9])/ // year between 1900 and 2199
export const validDateWhileTypingRegex = new RegExp(
  "^(" +
    `${dayWhileTypingRegex.source}|` +
    `${dayRegex.source}${separatorRegex.source}${monthWhileTypingRegex.source}?|` +
    `${dayRegex.source}${separatorRegex.source}${monthRegex.source}${separatorRegex.source}?|` +
    `${dayRegex.source}${separatorRegex.source}${monthRegex.source}${separatorRegex.source}${yearWhileTypingRegex.source}` +
    ")$",
)
